<template>
  <!-- Note: for 2-way binding to work with store state the easiest way
       is to go through the parent object (treePanel) in the binding -->
  <select class="inbox-type-select" v-model="inbox.filter.type">
    <option value="">any type</option>
    <option v-for="(typeDef, type) in typeDefs" :value="type">{{typeDef.name}}</option>
  </select>
</template>

<script>
export default {

  computed: {

    inbox () {
      return this.$store.state.inbox
    },

    typeDefs () {
      return this.$store.state.typeDefs
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// inbox-type-select.vue?5525f5be